import { useEffect, useState } from 'react';
import { CatalogResult, loadCatalog, snapshotCatalog } from './catalog';

/**
 * Starts with the bundled snapshot so the editor renders at once, then
 * switches to the cached or live storefront catalog when it arrives.
 */
export const useCatalog = (): CatalogResult & { loading: boolean } => {
  const [result, setResult] = useState<CatalogResult>(() => ({ catalog: snapshotCatalog(), source: 'snapshot' }));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    loadCatalog().then(next => {
      if (cancelled) return;
      setResult(next);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { ...result, loading };
};
